const HowItWorks = () => {
	return (
		<section className="mb-28">
			<img
				src="img/how-it-works-decoration-1.svg"
				alt="how-it-works-decoration"
				className="absolute -z-10 hidden md:block"
			/>
			<img
				src="img/how-it-works-decoration-2.svg"
				alt="how-it-works-decoration"
				className="absolute right-0 -z-10 hidden md:block"
			/>
			<h2 className="mb-12 text-center text-4xl font-extrabold">
				Jak to funguje
			</h2>
			<div className="container">
				{/* mobile */}
				<img
					src="img/how-it-works-decoration-left-mobile.svg"
					alt="how-it-works-decoration"
					className="absolute -z-10 md:hidden"
				/>
				<img
					src="img/how-it-works-decoration-right-mobile.svg"
					alt="how-it-works-decoration"
					className="absolute right-0 -z-10 md:hidden"
				/>
				<div className="relative flex flex-col items-center gap-2 px-8 lg:flex-row lg:justify-center lg:px-12 xl:px-28 2xl:px-64">
					<HowItWorksCard
						icon="img/how-it-works-start.webp"
						title="Úvodní seznámení"
						description="Na společném hovoru si řekneme zda pro vás máme řešení, které vám pomůže a ukážeme si celý proces aplikace."
					/>
					<img
						src="img/icons/how-it-works-right-arrow.svg"
						alt="arrow"
						className="rotate-90 md:rotate-0"
					/>
					<HowItWorksCard
						icon="img/how-it-works-design.webp"
						title="Návrh aplikace"
						description="Po první schůzce vám zašleme návrh řešení vaší aplikace s využitím. Po schválení se ihned dáváme do práce."
					/>
					<img
						src="img/icons/how-it-works-right-arrow.svg"
						alt="arrow"
						className="rotate-90 md:rotate-0"
					/>
					<div className="relative">
						<HowItWorksCard
							icon="img/how-it-works-launch.webp"
							title="Spouštění aplikace"
							description="Do 14 dnů vám dáme aplikaci otestovat, zodpovíme dotazy a doladíme poslední detaily. Aplikaci následně zveřejníme."
						/>
						<img
							src="img/how-it-works-decoration-left-mobile.svg"
							alt="how-it-works-decoration"
							className="absolute -left-8 -top-12 -z-10  md:hidden"
						/>
						<img
							src="img/how-it-works-decoration-right-mobile.svg"
							alt="how-it-works-decoration"
							className="absolute -right-8 top-12 -z-10 md:hidden"
						/>
					</div>
					<img
						src="img/icons/how-it-works-right-arrow.svg"
						alt="arrow"
						className="rotate-90 md:rotate-0"
					/>
					<div className="relative">
						<HowItWorksCard
							icon="img/how-it-works-results.webp"
							title="Měřitelné výsledky"
							description="Po spuštění vám budeme zasílat data z aplikace, se kterými následně můžeme
											pracovat a optimalizovat."
						/>
						<img
							src="img/how-it-works-decoration-left-mobile.svg"
							alt="how-it-works-decoration"
							className="absolute -left-8 top-24 -z-10  md:hidden"
						/>
					</div>
				</div>
			</div>
		</section>
	)
}

const HowItWorksCard = ({
	icon,
	title,
	description,
}: {
	icon: string
	title: string
	description: string
}) => {
	return (
		<div className="flex w-full flex-col items-center gap-8 rounded-[16px] bg-white p-8 text-center shadow-custom lg:h-[432px] lg:min-w-[247px]">
			<img src={icon} alt="how-it-works-start" height={128} width={128} />
			<div className="flex flex-col gap-2">
				<h3 className="text-xl font-bold text-secondary">{title}</h3>
				<p>{description}</p>
			</div>
		</div>
	)
}

export default HowItWorks
